import { useEffect, useState } from 'react';

import { useInfiniteQuery } from '@tanstack/react-query';

import { NOTIFICATION_STATUS } from '@api';

import { useMixPanel } from '@shared/common/providers/MixPanelProvider';
import { useSocket } from '@shared/common/providers/socket';

import { getNotificationInfiniteQueryOptions } from '@query/notification';

import { MIXPANEL_EVENT_NAMES } from '@api/mixPanel';

import { Actions } from '@ui/uikit/components/icons/mono/Actions';

import { useNavLayout } from './NavLayoutContext';
import { Notifications } from './Notifications';

const NotificationsButton = ({ portalMode }: { portalMode?: 'none' | 'default' | 'overlay' }) => {
  const { socket } = useSocket();

  const { user } = useNavLayout();
  const [isOpen, setIsOpen] = useState(false);
  const { track } = useMixPanel();

  const { data: hasUnreadNotification, refetch } = useInfiniteQuery({
    // NOTE: the same query options because logic for marking
    // notifications is implemented for the key that used inside it
    ...getNotificationInfiniteQueryOptions(),
    select: (data) =>
      data.pages.some((page) =>
        page.rows.some((notification) => notification.status === NOTIFICATION_STATUS.NEW),
      ),
    enabled: !!user?.data.id,
  });

  useEffect(() => {
    if (!socket) {
      return;
    }

    socket.on('notifications.update', () => {
      refetch();
    });

    return () => {
      socket.off('notifications.update');
    };
  }, [refetch, socket]);

  const onClickHandler = () => {
    track(MIXPANEL_EVENT_NAMES.INTERNAL_NOTIFICATIONS_CLICK, {
      distinct_id: user?.data.id,
    });

    setIsOpen(true);
  };

  return (
    <>
      <button
        onClick={onClickHandler}
        className="msq-btn msq-btn-icon-md msq-btn-ghost size-[2.25rem] text-base-text-primary md-msq:msq-btn-icon-lg"
        aria-label="View notifications"
      >
        <Actions className="msq-btn-icon-child-md" />
        {hasUnreadNotification && (
          <span className="size-2.5 md-msq:size-3 border-2 border-base-bg rounded-full bg-palette-pink-52 absolute top-0 right-0" />
        )}
      </button>

      <Notifications open={isOpen} onOpenChange={setIsOpen} portalMode={portalMode} />
    </>
  );
};

export default NotificationsButton;
